import { AnyAction, Reducer } from "redux";

import {
    SET_CURRENT_SELLER_INFO,
    SET_ALL_SELLERS,
    CLEAR_SELLERS_DATA,
    GET_CURRENT_USER_SELLERS_REQUEST_ERROR,
    SET_CURRENT_SELLER_STATISTIC,
    SET_CURRENT_SELLER_IS_LOADING,
    SET_CURRENT_SELLER_REQUEST_ERROR,
    SET_SELLER_REVIEWS_IFRAME_URL,
    SET_SELLER_AI_CLIENT_STATUS
} from "./constants";
import type { ISellersReducer } from "./types";


const initialState: ISellersReducer = {
    currentSeller: {
        info: {
            data: null,
            isLoading: false,
            error: null
        },
        statistic: null,
    },
    allSellers: [],
    requestError: null,
    isAllSellersLoaded: false,
}

const sellers: Reducer<ISellersReducer, AnyAction> = (state = initialState, action) => {
    switch (action.type) {

        case SET_ALL_SELLERS: {
            return {
                ...state,
                allSellers: action.payload,
                isAllSellersLoaded: true
            }
        }

        case SET_CURRENT_SELLER_INFO: {
            return {
                ...state,
                currentSeller: {
                    ...state.currentSeller,
                    info: {
                        ...state.currentSeller.info,
                        data: action.payload,
                        error: null
                    },
                }
            }
        }

        case SET_SELLER_AI_CLIENT_STATUS: {
            return {
                ...state,
                currentSeller: {
                    ...state.currentSeller,
                    info: {
                        ...state.currentSeller.info,
                        data: {
                            ...state.currentSeller.info.data,
                            isAiClient: action.payload
                        },
                        error: null
                    },
                }
            }
        }

        case SET_SELLER_REVIEWS_IFRAME_URL: {
            return {
                ...state,
                currentSeller: {
                    ...state.currentSeller,
                    info: {
                        ...state.currentSeller.info,
                        data: {
                            ...state.currentSeller.info.data,
                            aiIFrameUrl: action.payload
                        },
                        error: null
                    },
                }
            }
        }

        case SET_CURRENT_SELLER_IS_LOADING: {
            return {
                ...state,
                currentSeller: {
                    ...state.currentSeller,
                    info: {
                        ...state.currentSeller.info,
                        isLoading: action.payload
                    },
                }
            }
        }

        case SET_CURRENT_SELLER_REQUEST_ERROR: {
            return {
                ...state,
                currentSeller: {
                    ...state.currentSeller,
                    info: {
                        ...state.currentSeller.info,
                        data: null,
                        error: action.payload,
                    },
                }
            }
        }

        case CLEAR_SELLERS_DATA: {
            return {
                currentSeller: {
                    ...state.currentSeller,
                    info: {
                        data: null,
                        isLoading: null,
                        error: null,
                    },
                    statistic: null
                },
                allSellers: [],
                requestError: null,
                isAllSellersLoaded: false
            }
        }

        case GET_CURRENT_USER_SELLERS_REQUEST_ERROR: {
            return {
                ...state,
                allSellers: [],
                requestError: action.payload,
            }
        }

        case SET_CURRENT_SELLER_STATISTIC: {
            return {
                ...state,
                currentSeller: {
                    ...state.currentSeller,
                    statistic: action.payload
                }
            }
        }

        default: return state;
    }
}

export default sellers;